import { useAppBuilderContext } from 'app/app/editor/context';
import React, { useEffect, useRef, useState } from 'react';
import { merge } from 'ts-deepmerge';
import { IComponentNode } from 'app/app/editor/index.functions';
import StylesEditorContainer from 'app/app/editor/tabs/settings/style-editor/StylesEditorContainer';

export default function StylesEditor({ node }: { node: IComponentNode }) {
    const ctx = useAppBuilderContext();

    const [formState, setFormState] = useState<{ [key: string]: any }>({});
    const formStateRef = useRef(formState);
    useEffect(() => {
        formStateRef.current = formState;
    }, [formState]);
    const [isChange, setIsChange] = useState(false);

    useEffect(() => {
        setFormState(node.params?.layout ?? {});
    }, [node.params.uid]);

    useEffect(() => {
        setTimeout(() => {
            if (node.params.layout?.width && node.params.layout?.height) {
                if (
                    formStateRef.current?.width != node.params.layout.width ||
                    formStateRef.current?.height != node.params.layout.height
                ) {
                    setFormState({
                        ...formStateRef.current,
                        width: node.params.layout.width,
                        height: node.params.layout.height,
                        'size-type-width': node.params.layout['size-type-width'],
                        'size-type-height': node.params.layout['size-type-height'],
                    });
                }
            }
        }, 0);
    }, [
        node.params.layout?.width,
        node.params.layout?.height,
        node.params.layout?.['size-type-width'],
        node.params.layout?.['size-type-height'],
    ]);

    const applyChanges = () => {
        node.params.layout = merge(node.params?.layout ?? {}, structuredClone(formStateRef.current));
        ctx.setPage(ctx.page, false);
        ctx.sendMessage({
            name: 'updateComponent',
            data: { uid: node.params.uid, updateType: 'style' },
            broadcast: false,
        });
        ctx.sendMessage({ name: 'reloadPage' });
    };

    const onChangeStyle = (newData: any) => {
        setFormState((prevState) => ({ ...prevState, ...newData }));
        setIsChange(true);
    };

    useEffect(() => {
        if (isChange) {
            applyChanges();
        }
        setIsChange(false);
    }, [formState]);

    if (!node) {
        return null;
    }

    return (
        <StylesEditorContainer
            key={node.params.uid}
            uid={node.params.uid}
            formState={formState}
            setFormState={setFormState}
            onChangeStyle={onChangeStyle}
            node={node}
        />
    );
}
